<template>
  <div class="d-flex flex-column flex-md-row" data-cy="agenda-profissional-container">
    <div
      class="d-flex flex-column align-items-center justify-content-center p-2 bg-light border-right flex-grow-0 calendar-text-color font-weight-bold border-top agenda__profissional"
      data-cy="agenda-profissional-info"
    >
      <div data-cy="agenda-profissional-avatar-container">
        <avatar
          :username="profissional.nome"
          :size="60"
          :src="
            profissional.foto
              ? `${baseUrl}agendamentos/profissionais/${profissional.id}/foto`
              : ''
          "
          color="white"
          class="mb-3"
          data-cy="agenda-profissional-avatar"
        ></avatar>
      </div>
      <div class="d-flex flex-column text-center" style="width:250px;" data-cy="agenda-profissional-dados">
        <div data-cy="agenda-profissional-nome">{{ profissional | call }}</div>
        <div class="font-weight-normal" data-cy="agenda-profissional-registro">{{ profissional | id }}</div>
      </div>
    </div>
    <div class="d-flex flex-column flex-grow-1" data-cy="agenda-profissional-agendas">
      <agenda-geral-item
        v-for="agenda in filterHorariosAgenda"
        :reschedule="reschedule"
        :key="agenda.id"
        :agenda="agenda"
        @submit="submit"
        :data-cy="`agenda-profissional-agenda-item-${agenda.id}`"
      ></agenda-geral-item>
    </div>
  </div>
</template>

<script>
import AgendaGeralItem from "@/components/agenda-geral-item.vue";
import { generateTo } from "@/core/routerHelper.js";
import { axiosInstance as Axios } from "@/main";
import moment from "moment";
import Avatar from "vue-avatar";

export default {
  name: "agenda-geral-profissional",
  props: ["profissional", "reschedule"],
  computed: {
    baseUrl() {
      return this.$serverHost;
    },
    filterHorariosAgenda() {
      let agendasFiltered = this.profissional.agendas;
      agendasFiltered.forEach(agenda => {
        agenda.horarios = agenda.horarios.filter(horario => {
          const [horaInicioLabel, horaFimLabel] = horario.label.split(" - ");

          const horaInicioLocal = new Date(
            `${moment(horario.hora).format("YYYY-MM-DD")}T${horaInicioLabel}:00`
          );
          const horaFimLocal = new Date(
            `${moment(horario.hora).format("YYYY-MM-DD")}T${horaFimLabel}:00`
          );

          return agenda.multiplo
            ? horaFimLocal >= new Date()
            : horaInicioLocal >= new Date();
        });
      });
      return agendasFiltered;
    }
  },
  methods: {
    async submit(horario) {
      let profissional = this.profissional;
      profissional.stepId = 5;

      this.$store.dispatch("load_selected", profissional);

      if (this.reschedule === "false") {
        this.$store.dispatch("set_to", {
          name: generateTo(6, this.$route),
          params: { organizationId: this.$route.params.organizationId },
          query: {
            convenio: this.$route.query.convenio,
            especialidade: this.$route.query.especialidade,
            clinica: this.$route.query.clinica,
            horario: horario.id,
            medico: this.profissional.id,
            ...(localStorage.getItem("telemedicina")
              ? { telemedicina: localStorage.getItem("telemedicina") }
              : {})
          }
        });

        this.$emit("submit", this.profissional);

        this.$router.push(this.$store.getters.to);
      } else {
        try {
          await Axios.patch(
            `${this.$serverHost}protected/me/agendamentos/${this.$store.getters.reschedule.id}/reagendar`,
            {
              agendaId: this.$store.getters.get_selected[3].agendaId,
              horaAgendamento: this.$store.getters.get_selected[3].date
            },
            {
              headers: {
                Authorization: `Bearer ${this.$store.getters.token}`
              }
            }
          );

          this.$router.push({
            name: "history",
            params: { organizationId: this.$route.params.organizationId }
          });
        } catch (e) {
          console.error(e);
        }
      }
    }
  },
  filters: {
    call(value) {
      return `${value.tratamento} ${value.nome}`;
    },
    id(value) {
      return `${value.nomeConselhoProfissional ||
        "-"}: ${value.numeroConselhoProfissional || "-"} / ${value.estado}`;
    }
  },
  components: {
    AgendaGeralItem,
    Avatar
  }
};
</script>

<style>
.agenda__profissional {
  max-width: 250px;
}

.responsive-img {
  height: 50px;
  max-width: 100%;
}

@media (max-width: 768px) {
  .agenda__profissional {
    max-width: 100%;
    width: 100%;
    border-right: 0 !important;
  }
}
</style>
